import { Injectable } from "@angular/core";
import { RangosEdadEnum } from "@shared/enums";
import { datosCalculadora } from "./DatosCalculadora";

@Injectable({
    providedIn: "root"
})
export class Calculadora {
    public obtenerDias(paises: string[], rangosEdad: RangosEdadEnum[], cantidadCasos: number) {
        const maxDias: number[] = [];

        paises.forEach(pais => {
            const valoresDelPais = datosCalculadora[pais];
            const cantidadDeGrupos = rangosEdad.length;
            const cantidadPorGrupo = Math.floor(cantidadCasos / cantidadDeGrupos);

            rangosEdad.forEach(grupoEdad => {
                if (valoresDelPais) {
                    maxDias.push(
                        valoresDelPais[Calculadora.obtenerGrupoEdades(grupoEdad)]
                            .casos[Calculadora.obtenerDiaMax(cantidadPorGrupo)]
                    );
                }
            });
        });

        return Math.max(...(maxDias.length === 0 ? [1] : maxDias));
    }

    private static obtenerGrupoEdades(rangoEdad: RangosEdadEnum) {
        if (rangoEdad === RangosEdadEnum.DE_00_A_18) {
            return "DE16A20";
        }

        if (rangoEdad === RangosEdadEnum.DE_18_A_24) {
            return "DE20A30";
        }

        return "MAS30";
    }

    private static obtenerDiaMax(dia: number) {
        if (dia <= 100) {
            return 100;
        }

        if (dia <= 150) {
            return 150;
        }

        if (dia <= 200) {
            return 200;
        }

        if (dia <= 250) {
            return 250;
        }

        return 300;
    }
}
